import {useMutation} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    CreateUser as CreateUserMutation,
    CreateUserVariables as CreateUserMutationVariables,
    UserCreateInput,
} from 'nutshell-graphql-types';

import CREATE_USER from '../mutations/create-user.graphql';

export function useCreateUser(): {
    createUser: (arg1: UserCreateInput) => Promise<any>;
    isCreating: boolean;
    error: string | null | undefined;
    existingUserId: string | null | undefined;
} {
    const [createUser, {loading, error, data}] = useMutation<
        CreateUserMutation,
        CreateUserMutationVariables
    >(CREATE_USER);

    const isExistingUser = data && data.userCreate && data.userCreate.isExistingUser;

    let errorMessage = null;
    if (error) {
        // @ts-expect-error
        errorMessage = safelyGetGraphQLErrorMessage(error);
    } else if (isExistingUser) {
        // We want to treat an already existing user as an error state, even though we return the user
        errorMessage = 'User already exists';
    }

    return {
        createUser: (input: UserCreateInput) =>
            createUser({
                variables: {input},
            }),
        isCreating: loading,
        error: errorMessage,
        existingUserId: isExistingUser
            ? data && data.userCreate && data.userCreate.user && data.userCreate.user.id
            : null,
    };
}
